import { useLayoutEffect, useRef } from 'react';
import type { SwipeableMethods } from 'react-native-gesture-handler/ReanimatedSwipeable';

/**
 * Prevents ghost-swipe bugs when Swipeable items are recycled in FlashList.
 * Resets the swipeable drawer whenever any of the provided deps change
 * (typically the item id or key state driving the swipeable).
 */
export function useSwipeableReset(resetDeps: unknown[]) {
  const ref = useRef<SwipeableMethods | null>(null);
  const previousResetDeps = useRef(resetDeps);
  const isFirstReset = useRef(true);

  useLayoutEffect(() => {
    const previous = previousResetDeps.current;
    const dependenciesChanged =
      isFirstReset.current ||
      previous.length !== resetDeps.length ||
      resetDeps.some((dependency, index) => !Object.is(dependency, previous[index]));

    if (!dependenciesChanged) return;
    isFirstReset.current = false;
    previousResetDeps.current = resetDeps;
    ref.current?.reset();
  });

  return ref;
}
